module.exports = __webpack_public_path__ + "img/icon-calendar.564d7d6e.svg";